/* Moor & Halden - Brand Layer
   1) Rabatt-Fortschritt im Cart Drawer
   2) Groessenassistent (Damen / Herren / Schuhe)
*/
(function () {
  'use strict';

  var CFG = window.MH_CONFIG || {};
  var TIERS = CFG.tiers || [{ q: 2, p: 10 }, { q: 3, p: 15 }, { q: 4, p: 20 }];
  var MAXQ = TIERS[TIERS.length - 1].q;
  var MAILTO = CFG.email || 'info@moor-halden.com';

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ============ 1) CART PROGRESS ============ */
  var progHTML =
    '<div class="mh-prog" data-mh-prog>' +
      '<div class="mh-prog__t" data-mh-prog-text></div>' +
      '<div class="mh-prog__bar"><div class="mh-prog__fill" data-mh-prog-fill></div></div>' +
      '<div class="mh-prog__steps">' +
        TIERS.map(function (t) { return '<span data-mh-step="' + t.q + '">' + t.q + ' Artikel &middot; ' + t.p + '%</span>'; }).join('') +
      '</div>' +
    '</div>';

  var trustHTML =
    '<div class="mh-cart-trust">' +
      '<span><svg viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5"/></svg>Kostenloser Versand</span>' +
      '<span><svg viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5"/></svg>60 Tage Rückgabe</span>' +
      '<span><svg viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5"/></svg>Käuferschutz</span>' +
    '</div>';

  function ensureProgress() {
    var foot = $('#CartDrawer .drawer__footer') || $('.drawer__footer');
    if (foot && !$('[data-mh-prog]', foot)) {
      foot.insertAdjacentHTML('afterbegin', progHTML);
    }
    var wrap = $('#CartDrawer .cart__checkout-wrapper') || $('.cart__checkout-wrapper');
    if (wrap && !$('.mh-cart-trust', wrap.parentNode)) {
      wrap.insertAdjacentHTML('afterend', trustHTML);
    }
    // Cart page
    var pageFoot = $('.cart__footer');
    if (pageFoot && !$('[data-mh-prog]', pageFoot)) {
      pageFoot.insertAdjacentHTML('afterbegin', progHTML);
    }
  }

  function renderProgress(count) {
    ensureProgress();
    var current = 0, next = null;
    for (var i = 0; i < TIERS.length; i++) {
      if (count >= TIERS[i].q) current = TIERS[i].p;
      else { next = TIERS[i]; break; }
    }
    var pct = Math.min(100, Math.round((count / MAXQ) * 100));
    $$('[data-mh-prog-fill]').forEach(function (el) { el.style.width = pct + '%'; });
    var msg;
    if (count === 0) {
      msg = 'Ab <b>2 Artikeln</b> sparen Sie <b>10&nbsp;%</b> &ndash; ab 4 Artikeln 20&nbsp;%.';
    } else if (next) {
      var need = next.q - count;
      msg = 'Noch <b>' + need + ' Artikel</b> und Sie erhalten <b>' + next.p + '&nbsp;% Rabatt</b>' +
            (current ? ' (aktuell ' + current + '&nbsp;%)' : '') + '.';
    } else {
      msg = 'Geschafft &ndash; <b>' + current + '&nbsp;% Mengenrabatt</b> werden im Checkout abgezogen.';
    }
    $$('[data-mh-prog-text]').forEach(function (el) { el.innerHTML = msg; });
    $$('[data-mh-step]').forEach(function (el) {
      el.classList.toggle('on', count >= parseInt(el.getAttribute('data-mh-step'), 10));
    });
  }

  var syncTimer = null;
  function syncCart() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { renderProgress(c.item_count || 0); })
        .catch(function () {});
    }, 130);
  }

  // watch cart mutations
  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function () {
      var url = arguments[0];
      var u = (typeof url === 'string') ? url : (url && url.url) || '';
      var p = _fetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(u)) { p.then(function () { syncCart(); }).catch(function () {}); }
      return p;
    };
  }
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    if (typeof u === 'string' && /\/cart\/(add|change|update|clear)/.test(u)) {
      this.addEventListener('load', syncCart);
    }
    return _open.apply(this, arguments);
  };

  /* ============ 2) SIZE ASSISTANT ============ */
  var W_SIZES = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];
  var W_BASE = [
    { max: 52, i: 0 }, { max: 58, i: 1 }, { max: 66, i: 2 }, { max: 75, i: 3 },
    { max: 85, i: 4 }, { max: 97, i: 5 }, { max: 110, i: 6 }, { max: 124, i: 7 }, { max: 999, i: 8 }
  ];
  var M_BASE = [
    { max: 62, i: 0 }, { max: 70, i: 1 }, { max: 82, i: 2 }, { max: 92, i: 3 },
    { max: 104, i: 4 }, { max: 118, i: 5 }, { max: 132, i: 6 }, { max: 146, i: 7 }, { max: 999, i: 8 }
  ];

  function baseIndex(table, kg) {
    for (var i = 0; i < table.length; i++) { if (kg <= table[i].max) return table[i].i; }
    return table[table.length - 1].i;
  }

  function normKey(v) {
    return String(v).toUpperCase().replace(/\s|-/g, '')
      .replace('XXXXXL', '5XL').replace('XXXXL', '4XL').replace('XXXL', '3XL').replace('XXL', '2XL');
  }

  function snapToAvailable(idx, available) {
    var mapped = available.map(function (v) {
      var k = normKey(v);
      var i = W_SIZES.indexOf(k);
      return { raw: v, i: i };
    }).filter(function (o) { return o.i >= 0; });
    if (!mapped.length) return null;
    mapped.sort(function (a, b) { return a.i - b.i; });
    var best = mapped[0], bd = Math.abs(mapped[0].i - idx);
    mapped.forEach(function (o) {
      var d = Math.abs(o.i - idx);
      if (d < bd || (d === bd && o.i > best.i)) { bd = d; best = o; }
    });
    return best;
  }

  function computeApparel(g, cm, kg, statur, mitte, fit, cat) {
    var table = (g === 'herren') ? M_BASE : W_BASE;
    var idx = baseIndex(table, kg);
    var refH = (g === 'herren') ? 180 : 168;
    var dh = cm - refH;
    if (dh >= 12) idx += 0.5; else if (dh <= -10) idx -= 0.5;
    idx += ({ schlank: -0.5, normal: 0, kraeftig: 0.5 })[statur] || 0;
    idx += ({ schmal: -0.5, ausgeglichen: 0, kraeftig: 0.5 })[mitte] || 0;
    idx += ({ eng: -0.5, normal: 0, locker: 1 })[fit] || 0;
    if (cat === 'outerwear') idx += 0.5;
    if (cat === 'kleid' || cat === 'bluse') idx += 0.25;
    idx = Math.round(Math.max(0, Math.min(W_SIZES.length - 1, idx)));
    return idx;
  }

  function computeShoe(current, width) {
    var n = parseFloat(String(current).replace(',', '.'));
    if (isNaN(n)) return null;
    if (width === 'breit') n += 1;
    if (width === 'schmal') n -= 0;
    return Math.round(n);
  }

  function snapShoe(target, available) {
    var nums = available.map(function (v) { return { raw: v, n: parseFloat(String(v).replace(',', '.')) }; })
      .filter(function (o) { return !isNaN(o.n); });
    if (!nums.length) return null;
    var best = nums[0], bd = Math.abs(nums[0].n - target);
    nums.forEach(function (o) { var d = Math.abs(o.n - target); if (d < bd) { bd = d; best = o; } });
    return best;
  }

  /* ---- Modal ---- */
  function buildModal() {
    if ($('#MHSizeModal')) return $('#MHSizeModal');
    var el = document.createElement('div');
    el.id = 'MHSizeModal';
    el.className = 'mh-mod';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.innerHTML =
      '<div class="mh-mod__bg" data-mh-close></div>' +
      '<div class="mh-mod__box">' +
        '<button class="mh-mod__x" type="button" data-mh-close aria-label="Schließen">&times;</button>' +
        '<div data-mh-body></div>' +
      '</div>';
    document.body.appendChild(el);
    el.addEventListener('click', function (e) {
      if (e.target.hasAttribute && e.target.hasAttribute('data-mh-close')) closeModal();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
    return el;
  }

  function openModal() { buildModal().classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeModal() { var m = $('#MHSizeModal'); if (m) m.classList.remove('is-open'); document.body.style.overflow = ''; }

  function chips(name, opts, def) {
    return '<div class="mh-chips" data-mh-chips="' + name + '">' + opts.map(function (o) {
      return '<button type="button" class="mh-chip' + (o.v === def ? ' on' : '') + '" data-v="' + o.v + '">' + o.l + '</button>';
    }).join('') + '</div>';
  }

  function stepApparel(P) {
    var isW = P.gender !== 'herren';
    var body = $('[data-mh-body]', buildModal());
    body.innerHTML =
      '<h3>In 20 Sekunden zu Ihrer Größe</h3>' +
      '<p class="mh-mod__sub">Vier kurze Angaben &ndash; wir empfehlen Ihnen die Größe, die bei diesem Schnitt am besten sitzt.</p>' +
      '<div class="mh-2">' +
        '<div class="mh-f"><label for="mhH">Körpergröße (cm)</label><input id="mhH" type="number" inputmode="numeric" min="140" max="215" placeholder="' + (isW ? '168' : '180') + '"></div>' +
        '<div class="mh-f"><label for="mhW">Gewicht (kg)</label><input id="mhW" type="number" inputmode="numeric" min="35" max="200" placeholder="' + (isW ? '65' : '80') + '"></div>' +
      '</div>' +
      '<div class="mh-f"><label>Statur</label>' + chips('statur', [
        { v: 'schlank', l: 'Eher schlank' }, { v: 'normal', l: 'Normal' }, { v: 'kraeftig', l: 'Eher kräftig' }], 'normal') + '</div>' +
      '<div class="mh-f"><label>' + (isW ? 'Taille & Hüfte' : 'Bauchumfang') + '</label>' + chips('mitte', [
        { v: 'schmal', l: 'Eher schmal' }, { v: 'ausgeglichen', l: 'Ausgeglichen' }, { v: 'kraeftig', l: 'Eher kräftig' }], 'ausgeglichen') + '</div>' +
      '<div class="mh-f"><label>Wie mögen Sie es tragen?</label>' + chips('fit', [
        { v: 'eng', l: 'Körpernah' }, { v: 'normal', l: 'Normal' }, { v: 'locker', l: 'Locker' }], 'normal') + '</div>' +
      '<p class="mh-mod__err" data-mh-err>Bitte Körpergröße und Gewicht angeben.</p>' +
      '<button type="button" class="btn" data-mh-go>Größe berechnen</button>' +
      '<p class="mh-mod__foot">Unsicher? Schreiben Sie uns an <a href="mailto:' + MAILTO + '">' + MAILTO + '</a> &ndash; wir beraten Sie persönlich, meist innerhalb weniger Stunden.</p>';
    wireChips(body);
    $('[data-mh-go]', body).addEventListener('click', function () {
      var cm = parseFloat($('#mhH').value), kg = parseFloat($('#mhW').value);
      if (!cm || !kg || cm < 130 || kg < 30) { $('[data-mh-err]', body).style.display = 'block'; return; }
      var idx = computeApparel(P.gender, cm, kg, getChip(body, 'statur'), getChip(body, 'mitte'), getChip(body, 'fit'), P.category);
      var hit = snapToAvailable(idx, P.sizes);
      showResult(P, hit ? hit.raw : W_SIZES[idx], hit ? null : 'Diese Größe ist aktuell nicht verfügbar.', idx);
    });
  }

  function stepShoe(P) {
    var body = $('[data-mh-body]', buildModal());
    body.innerHTML =
      '<h3>In 20 Sekunden zu Ihrer Größe</h3>' +
      '<p class="mh-mod__sub">Sagen Sie uns, welche Größe Sie sonst tragen &ndash; wir gleichen sie mit diesem Modell ab.</p>' +
      '<div class="mh-2">' +
        '<div class="mh-f"><label for="mhS">Ihre übliche EU-Schuhgröße</label><input id="mhS" type="number" inputmode="numeric" min="33" max="50" placeholder="41"></div>' +
        '<div class="mh-f"><label for="mhF">Fußlänge (cm, optional)</label><input id="mhF" type="number" inputmode="decimal" step="0.5" min="20" max="34" placeholder="26,5"></div>' +
      '</div>' +
      '<div class="mh-f"><label>Fußbreite</label>' + chips('width', [
        { v: 'schmal', l: 'Schmal' }, { v: 'normal', l: 'Normal' }, { v: 'breit', l: 'Breit / hoher Spann' }], 'normal') + '</div>' +
      '<div class="mh-f"><label>Tragen Sie dicke Socken?</label>' + chips('socks', [
        { v: 'nein', l: 'Eher nicht' }, { v: 'ja', l: 'Ja, häufig' }], 'nein') + '</div>' +
      '<p class="mh-mod__err" data-mh-err>Bitte Schuhgröße oder Fußlänge angeben.</p>' +
      '<button type="button" class="btn" data-mh-go>Größe berechnen</button>' +
      '<p class="mh-mod__foot">Unsicher? Schreiben Sie uns an <a href="mailto:' + MAILTO + '">' + MAILTO + '</a> &ndash; wir beraten Sie persönlich.</p>';
    wireChips(body);
    $('[data-mh-go]', body).addEventListener('click', function () {
      var s = parseFloat($('#mhS').value);
      var f = parseFloat(String($('#mhF').value).replace(',', '.'));
      if (!s && !f) { $('[data-mh-err]', body).style.display = 'block'; return; }
      if (!s && f) s = Math.round((f + 1.5) / 0.667);
      var t = computeShoe(s, getChip(body, 'width'));
      if (getChip(body, 'socks') === 'ja') t += 0;
      var hit = snapShoe(t, P.sizes);
      showResult(P, hit ? hit.raw : String(t), hit ? null : 'Diese Größe ist aktuell nicht verfügbar.', null);
    });
  }

  function wireChips(scope) {
    $$('[data-mh-chips]', scope).forEach(function (g) {
      g.addEventListener('click', function (e) {
        var b = e.target.closest('.mh-chip'); if (!b) return;
        $$('.mh-chip', g).forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
      });
    });
  }
  function getChip(scope, name) {
    var on = $('[data-mh-chips="' + name + '"] .mh-chip.on', scope);
    return on ? on.getAttribute('data-v') : '';
  }

  function showResult(P, size, warn, idx) {
    var body = $('[data-mh-body]', buildModal());
    var note = P.isShoe
      ? 'Dieses Modell fällt normal aus. Bei breitem Fuß empfehlen wir eine Nummer größer.'
      : (P.category === 'outerwear'
        ? 'Für dieses Modell haben wir etwas Platz zum Drüberziehen eingerechnet.'
        : 'Basierend auf Ihren Angaben und dem Schnitt dieses Modells.');
    var alt = '';
    if (!P.isShoe && idx !== null) {
      var down = snapToAvailable(idx - 1, P.sizes), up = snapToAvailable(idx + 1, P.sizes);
      var parts = [];
      if (down && down.raw !== size) parts.push('enger: <b>' + down.raw + '</b>');
      if (up && up.raw !== size) parts.push('lockerer: <b>' + up.raw + '</b>');
      if (parts.length) alt = '<p class="mh-res__alt">Alternativ &ndash; ' + parts.join(' &nbsp;·&nbsp; ') + '</p>';
    }
    body.innerHTML =
      '<h3>Ihre Empfehlung</h3>' +
      '<div class="mh-res">' +
        '<div class="mh-res__lab">Empfohlene Größe</div>' +
        '<div class="mh-res__v">' + size + '</div>' +
        '<p class="mh-res__n">' + (warn ? warn + ' ' : '') + note + '</p>' +
        alt +
      '</div>' +
      '<button type="button" class="btn" data-mh-add data-size="' + String(size).replace(/"/g, '') + '">Größe ' + size + ' in den Warenkorb</button>' +
      '<p style="text-align:center;margin:12px 0 0"><button type="button" class="mh-btn-ghost" data-mh-again style="font-size:12px;padding:9px 18px">Angaben ändern</button></p>' +
      '<p class="mh-mod__foot">Passt doch nicht? 60 Tage Rückgaberecht &ndash; oder fragen Sie uns vorab unter <a href="mailto:' + MAILTO + '">' + MAILTO + '</a>.</p>';
    $('[data-mh-again]', body).addEventListener('click', function () { start(P); });
    $('[data-mh-add]', body).addEventListener('click', function () { selectAndAdd(P, size); });
  }

  function selectAndAdd(P, size) {
    var target = normKey(size);
    var hit = null;
    $$('.variant-input input[data-variant-input]').forEach(function (inp) {
      var idxAttr = inp.getAttribute('data-index');
      if (idxAttr !== P.sizeIndexKey) return;
      if (normKey(inp.value) === target) hit = inp;
    });
    if (hit) {
      hit.checked = true;
      hit.dispatchEvent(new Event('change', { bubbles: true }));
      hit.click();
    }
    closeModal();
    setTimeout(function () {
      var btn = $('[data-add-to-cart]') || $('.add-to-cart') || $('button[name="add"]');
      if (btn && !btn.disabled) btn.click();
    }, 260);
  }

  function start(P) {
    openModal();
    if (P.isShoe) stepShoe(P); else stepApparel(P);
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-mh-size-open]');
    if (!t) return;
    e.preventDefault();
    var P = window.MH_PRODUCT || {};
    if (!P.sizes || !P.sizes.length) { window.location.href = '/pages/grossentabelle'; return; }
    start(P);
  });

  /* ============ init ============ */
  function init() {
    ensureProgress();
    syncCart();
    var cd = $('#CartDrawer');
    if (cd) {
      new MutationObserver(function () { ensureProgress(); }).observe(cd, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
